import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'Victory Plumbing';
const DEFAULT_DESC = 'Victory Plumbing is a family-owned, Class II Master Plumber (MP#210521) serving Savannah, GA and the Coastal Empire with residential, commercial & industrial plumbing since 2021.';
const OG_IMAGE = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_lowcountry-test/artifacts/hj7l1f73_unnamed.png';

export default function Seo({ title, description, path = '' }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Savannah's Trusted Plumber`;
  const desc = description || DEFAULT_DESC;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const url = origin + path;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
